import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UtilsService } from './utils.service';
import { SignInService } from './sign-in.service';
import { UpdateService } from './update.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService {
  apiCount: number = 0;
  constructor(public signInSvc: SignInService, private utils: UtilsService, private swSvc: UpdateService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.apiCount++;
    if (this.apiCount == 10) {
      this.swSvc.checkForUpdate();
      this.apiCount = 0;
    }
    let dateTime = new Date();
    this.utils.setItemToLocalStorage('lms_action', String(dateTime.toISOString()));
    let byPassFlag = this.checkForByPassHttpInterceptorUrl(request);
    let isTmpTokenAdd = request.headers.get('addTempTokenHeader') ? request.headers.get('addTempTokenHeader') : false;
    if (!byPassFlag && !isTmpTokenAdd) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.utils.getToken() ? this.utils.getToken() : ''}`,
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }
      }); return next.handle(request);
    }
    else if (!byPassFlag && isTmpTokenAdd) {
      request.headers.delete('addTempTokenHeader');
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.utils.getTmpUserToken() ? this.utils.getTmpUserToken() : ''}`,
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }
      }); return next.handle(request);
    }
    else {
      const newHeaders = request.headers.delete('InterceptorSkipHeader');
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.utils.getToken()}`,
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }
      });
      request = request.clone({ headers: newHeaders }); return next.handle(request);
    }
  }

  checkForByPassHttpInterceptorUrl(request: any) {
    if (request.headers.get('InterceptorSkipHeader')) {
      return true;
    }
    // if (request.url == `${this.utils.apiUrl}Account/RefreshToken`) {
    //   return true;
    // }
    else
      return false
  }
}